// --- helpers de contraste (item 6: texto do navbar acompanha a página) ---
function parseHex(hex) {
    if (!hex || typeof hex !== 'string') return null;
    let h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map(c => c + c).join('');
    if (h.length !== 6) return null;
    return {
        r: parseInt(h.substr(0, 2), 16),
        g: parseInt(h.substr(2, 2), 16),
        b: parseInt(h.substr(4, 2), 16),
    };
}

function relativeLuminance(rgb) {
    const ch = ['r', 'g', 'b'].map((k) => {
        const c = rgb[k] / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * ch[0] + 0.7152 * ch[1] + 0.0722 * ch[2];
}

function contrastRatio(hexA, hexB) {
    const a = parseHex(hexA);
    const b = parseHex(hexB);
    if (!a || !b) return 21;
    const la = relativeLuminance(a);
    const lb = relativeLuminance(b);
    const light = Math.max(la, lb);
    const dark = Math.min(la, lb);
    return (light + 0.05) / (dark + 0.05);
}

export default {
    state: {
        fixed: false,
        position: false,
        color: {},
        pageColor: null,
        navTextFollow: false
    },
    mutations: {
        SET_NAVBAR_FIXED(state, payload) {
            state.fixed = payload
        },
        SET_NAVBAR_POSITION(state, payload) {
            state.position = payload
        },
        SET_COLOR(state, payload) {
            state.color = payload
        },
        // Cor da página atual (custom page) — usada pelo filete quando
        // configurado para acompanhar a página.
        SET_PAGE_COLOR(state, payload) {
            state.pageColor = payload
        },
        SET_NAV_TEXT_FOLLOW(state, payload) {
            state.navTextFollow = !!payload
        }
    },
    getters: {
        NAVBAR_FIXED(state) {
            return state.fixed
        },
        NAVBAR_POSITION(state){
            return state.position
        },
        COLOR(state) {
            return state.color
        },
        PAGE_COLOR(state) {
            return state.pageColor
        },
        // Cor efetiva do navbar. Quando "texto acompanha a página" está ativo e
        // há uma página custom, o texto/menus usam a cor da página — mas só se
        // tiver contraste suficiente contra o fundo do navbar (primary); senão
        // cai para branco/preto legível (auto-contraste, nunca some).
        NAV_COLOR(state) {
            const base = state.color || {};
            if (!state.navTextFollow || !state.pageColor) return base;

            const bg = base.primary || '#ffffff';
            const candidate = state.pageColor;
            const MIN_CONTRAST = 3; // limiar p/ texto de UI

            let secondary;
            if (contrastRatio(candidate, bg) >= MIN_CONTRAST) {
                secondary = candidate;
            } else {
                // fallback legível contra o fundo do navbar
                secondary = contrastRatio('#ffffff', bg) >= contrastRatio('#212121', bg)
                    ? '#ffffff'
                    : '#212121';
            }
            return { ...base, secondary };
        }
    }
}